const MODULE_NAME = 'fulcrum/container/Project/FileUploadDialogNvqual'
const RESET_ACTIVE = 'fulcrum/container/Project/FileUploadDialogNvqual/RESET_ACTIVE'
const UPDATE_ACTIVE = 'fulcrum/container/Project/FileUploadDialogNvqual/UPDATE_ACTIVE'

const UPDATE_PAGE = 'fulcrum/container/Project/FileUploadDialogNvqual/UPDATE_PAGE'
const RESET_PAGE = 'fulcrum/container/Project/FileUploadDialogNvqual/RESET_PAGE'
const CHANGE_PAGE = 'fulcrum/container/Project/FileUploadDialogNvqual/CHANGE_PAGE'
const CHANGE_ACTIVE = 'fulcrum/container/Project/FileUploadDialogNvqual/CHANGE_ACTIVE'

const DROP_REJECTED = 'fulcrum/container/Project/FileUploadDialogNvqual/DROP_REJECTED'

const UPDATE_REPORT_BODY = 'fulcrum/container/Project/FileUploadDialogNvqual/UPDATE_REPORT'
const UPDATE_REPORT_URL = 'fulcrum/container/Project/FileUploadDialogNvqual/UPDATE_REPORT_URL'

const POST_UPLOAD_FILE = 'fulcrum/container/Project/FileUploadDialogNvqual/POST_UPLOAD_FILE'
const POST_UPLOAD_FILE_START = 'fulcrum/container/Project/FileUploadDialogNvqual/POST_UPLOAD_FILE_START'
const POST_UPLOAD_FILE_SUCCESS = 'fulcrum/container/Project/FileUploadDialogNvqual/POST_UPLOAD_FILE_SUCCESS'
const POST_UPLOAD_FILE_ERROR = 'fulcrum/container/Project/FileUploadDialogNvqual/POST_UPLOAD_FILE_ERROR'

const NEW_REVISION_NAME_CHANGE = 'fulcrum/container/Project/FileUploadDialogNvqual/NEW_REVISION_NAME_CHANGE'
const ADD_FILES = 'fulcrum/container/Project/FileUploadDialogNvqual/ADD_FILES'

const NEW_REVISION_NAME_CLEAR = 'fulcrum/container/Project/FileUploadDialogNvqual/NEW_REVISION_NAME_CLEAR'
const CLEAR_ADD_FILES = 'fulcrum/container/Project/FileUploadDialogNvqual/CLEAR_ADD_FILES'

const TOGGLE_NVBUG_CHECKBOX = 'fulcrum/container/Project/FileUploadDialogNvqual/TOGGLE_NVBUG_CHECKBOX'

const FILE_ACCEPT_TYPE = [
  'application/vnd.ms-excel',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
]

const FILE_TYPE_STRING = [
  '.zip',
  '.xlsm',
]


const MAX_SIZE = 262144000//50mb

const PAGE = Object.freeze({
  FILE_SELECTION: 0,
  UPLOADING: 1,
})

export {
  PAGE,
  MODULE_NAME,
  RESET_ACTIVE,
  UPDATE_ACTIVE,
  UPDATE_PAGE,
  RESET_PAGE,
  CHANGE_ACTIVE,
  CHANGE_PAGE,
  DROP_REJECTED,
  POST_UPLOAD_FILE,
  POST_UPLOAD_FILE_START,
  POST_UPLOAD_FILE_SUCCESS,
  POST_UPLOAD_FILE_ERROR,
  MAX_SIZE,
  FILE_ACCEPT_TYPE,
  FILE_TYPE_STRING,
  UPDATE_REPORT_BODY,
  UPDATE_REPORT_URL,
  NEW_REVISION_NAME_CHANGE,
  ADD_FILES,
  NEW_REVISION_NAME_CLEAR,
  CLEAR_ADD_FILES,
  TOGGLE_NVBUG_CHECKBOX
}
